import { WithdrawalType } from "../../interfaces/withdrawal";

interface WithdrawalTypeLabelProps {
    value?: WithdrawalType;
}

const types: Record<WithdrawalType | "default", string> = {
    user: "Usuário",
    driver: "Motorista",
    manager: "Gerente",
    default: "Não definido",
};

export function WithdrawalTypeLabel({ value }: WithdrawalTypeLabelProps) {
    const type = value ? types[value] : types.default;
    return <span>{type}</span>;
}
